/// <reference path="../../typings/index.d.ts"/>

import * as React from "react";
import * as ReactDOM from "react-dom";

export interface ProfileProps extends React.Props<Profile> {
    className?: string;
    user: any;
}

export interface ProfileState {
    mapInitialized: boolean;
    map: any;
}

const w = window;

export class Profile extends React.Component<ProfileProps, ProfileState> {
    constructor(props: ProfileProps) {
        super(props);

        this.state = {
            mapInitialized: false,
            map: null
        }
    }

    public render() {
        //this.refreshMap();
        return (
            <div className='profile'>
                <div className="profile__left">
                    <img ref='img' className='profile__image' src={this.props.user.src} />
                </div>
                <div className="profile__right">
                    <div className='profile__name'>{this.props.user.displayName}</div>
                    <div className='profile__status'>
                        {this.props.user.status ? this.props.user.status:'-'}
                    </div>
                    <div className={'profile__locale' + (this.props.user.locale ? '':' hidden')}>At {this.props.user.locale}</div>
                    <div ref="map" className="profile__map"/>
                </div>
            </div>
        )
    }

    public componentDidMount() {
        this.initializeMap()
    }

    public refreshMap() {
        if (this.state.map) {
            let latitude = this.props.user.latitude;
            let longitude  = this.props.user.longitude;
            let coords  = new w.google.maps.LatLng(latitude,longitude);
            this.state.map.panTo(coords);
        }
    }

    public initializeMap() {
        if (this.props.user && !this.state.mapInitialized) {
            let styles = [{"featureType":"landscape","stylers":[{"saturation":-100},{"lightness":35},{"visibility":"on"}]},{"featureType":"poi","stylers":[{"saturation":-100},{"lightness":31},{"visibility":"simplified"}]},{"featureType":"road.highway","stylers":[{"saturation":-100},{"visibility":"simplified"}]},{"featureType":"road.arterial","stylers":[{"saturation":-100},{"lightness":30},{"visibility":"on"}]},{"featureType":"road.local","stylers":[{"saturation":-100},{"lightness":40},{"visibility":"on"}]},{"featureType":"transit","stylers":[{"saturation":-100},{"visibility":"simplified"}]},{"featureType":"administrative.province","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"labels","stylers":[{"visibility":"on"},{"lightness":-25},{"saturation":-100}]},{"featureType":"water","elementType":"geometry","stylers":[{"hue":"#ffff00"},{"lightness":-25},{"saturation":-97}]}];

            let latitude = this.props.user.latitude;
            let longitude  = this.props.user.longitude;
            let coords  = new w.google.maps.LatLng(latitude,longitude);
            let map = new w.google.maps.Map(ReactDOM.findDOMNode(this.refs['map']), {
                center: coords,
                zoom: 15,
                disableDefaultUI: true,
                zoomControl: false,
                scrollwheel: false,
                draggable: false,
                styles: styles
            });
            var marker = new w.google.maps.Marker({
                position: coords,
                map: map,
                title: 'Me',
                icon: '/images/marker.png'
            });

            this.setState({
                mapInitialized: true,
                map: map
            });
        }
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/Profile.tsx
 **/